<div class="timeline" [attr.data-tripStatus]="order().tripStatus">
  <mat-icon>place</mat-icon>
  <div
    class="circle"
    [class]="{ active: order().tripStatus === 'Scheduled', complete: order().tripStatus !== 'Scheduled' }"
  ></div>
  <div
    class="circle"
    [class]="{ active: order().tripStatus === 'InTransit', complete: order().tripStatus === 'Delivered' }"
  ></div>
  <div class="circle" [class]="{ active: order().tripStatus === 'Delivered' }"></div>
</div>
<div class="trip-status">
  @switch (order().tripStatus) {
    @case ('InTransit') {
      Order in transit
    }
    @case ('Delivered') {
      Delivered
    }
    @default {
      Order preparing for shipment
    }
  }
</div>
